import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "confetti" }

import { onMounted, onUnmounted, ref } from 'vue'

interface ConfettiPiece {
  id: number
  left: number
  color: string
  delay: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Confetti',
  props: {
    burstOnMount: { type: Boolean, default: true }
  },
  setup(__props: any, { expose: __expose }) {

const COLORS = ['#ffc906', '#51b06f', '#209bf5', '#ff7124', '#f3be00']

const props = __props

onMounted(() => {
  if (props.burstOnMount) {
    burst()
  }
})

onUnmounted(() => {
  clearTimeout(cleanupTimeout.value)
})

const confetti = ref<ConfettiPiece[]>([])
const cleanupTimeout = ref<number>()

function burst(): void {
  confetti.value = Array.from({ length: 30 }, (_, index) => ({
    id: index,
    left: 6 + Math.random() * 88,
    color: COLORS[index % COLORS.length],
    delay: Math.random() * 0.3,
  }))

  // Cleanup the confetti particles after the animation is done.
  cleanupTimeout.value = setTimeout(() => {
    confetti.value = []
  }, 3000)
}

__expose({
  burst,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(confetti.value, (piece) => {
      return (_openBlock(), _createElementBlock("span", {
        key: piece.id,
        style: _normalizeStyle({
        left: `${piece.left}%`,
        background: piece.color,
        animationDelay: `${piece.delay}s`,
      })
      }, null, 4))
    }), 128))
  ]))
}
}

})